import TableContainer from '@mui/material/TableContainer';
import FormControl from '@mui/material/FormControl';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import {useTranslation} from "react-i18next";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import Grid from '@mui/material/Grid';
import React from 'react';
import {TAB_YEAR, TAB_LIFER, TAB_LOC, TAB_MONTH, TAB_COMPARE, TAB_OBS, TAB_TRIP, TAB_WINTER, TAB_ASSO} from './StatsCommon.js';
import {monthNames, getCountryName, getCityName} from '../Trans.js'
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import StatsRow from './StatsRow.js';

export function getTabStr(tab) {
	switch (tab) {
		case TAB_YEAR:
			return 'stats.year';
		case TAB_LIFER:
			return 'stats.lifers';
		case TAB_LOC:
			return 'stats.locations';
		case TAB_MONTH:
			return 'stats.month';
		case TAB_OBS:
			return 'stats.obs';
		case TAB_TRIP:
			return 'stats.trip';
		case TAB_WINTER:
			return 'stats.winter';
		case TAB_ASSO:
			return 'stats.association';
		default:
			console.error('getTabStr: invalid tab:', tab);
	}

	return '-';
}

const StatsCompare = ((props) => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	function compareGetCityName(city_id) {
		const city = gStorage.lists.citylist.list.find(l => l.id === city_id);

		return getCityName(city, gStorage.conn.user);
	}

	function getLocDesc(id) {
		if (!id)
			return '';

		const loc = gStorage.lists.loclist.list.find(l => l.id === id);
		if (!loc)
			return '??';

		return loc.name;
	}

	function cmpDesc() {
		let desc;

		desc = '-';

		if (gStorage.stats.leftList.list.length) {
			const tab = gStorage.stats.leftList.tab;
			const rawstr = getTabStr(tab);

			desc = t(rawstr);
			if (tab === TAB_YEAR) {
				desc += ' ' + gStorage.stats.leftList.year;
			} else if (tab === TAB_LOC) {
				if (gStorage.stats.leftList.location > 0) {
					desc += ' ' + getLocDesc(gStorage.stats.leftList.location);
				} else if (gStorage.stats.leftList.location < 0) {
					/* Custom: Kunta */
					desc += ' ' + compareGetCityName(-gStorage.stats.leftList.location);
				} else {
					desc += ' ??';
				}
			} else if (tab === TAB_ASSO) {
				const y = gStorage.stats.leftList.year;

				desc += ' ' + gStorage.lists.assolist.list.find(l => l.id === gStorage.stats.leftList.location).nick;
				if (y) {
					desc += ', ' + y;
				}
			} else if (tab === TAB_MONTH) {
				const m = gStorage.stats.leftList.month;

				if (m >= 1 && m <= 12) {
					const y = gStorage.stats.leftList.year;

					desc += ' ' + t(monthNames[gStorage.stats.leftList.month - 1]);
					if (y) {
						desc += ', ' + y;
					}
				}
			}

			if (gStorage.stats.leftList.country && (tab !== TAB_LOC && tab !== TAB_OBS && tab !== TAB_ASSO)) {
				desc += ' (' + getCountryName(gStorage.lists.countrylist.find(x => x.id === gStorage.stats.leftList.country), gStorage.conn.user) + ')';
			}
		}

		desc += ' vs. '
		
		if (gStorage.stats.rightList.list.length) {
			const tab = gStorage.stats.rightList.tab;
			const rawstr = getTabStr(tab);

			desc += t(rawstr);

			if (gStorage.stats.rightList.tab === TAB_YEAR) {
				desc += ' ' + gStorage.stats.rightList.year;
			} else if (gStorage.stats.rightList.tab === TAB_LOC) {
				if (gStorage.stats.rightList.location > 0) {
					desc += ' ' + getLocDesc(gStorage.stats.rightList.location);
				} else if (gStorage.stats.rightList.location < 0) {
					/* Custom: Kunta */
					desc += ' ' + compareGetCityName(-gStorage.stats.rightList.location);
				} else {
					desc += ' ??';
				}
			} else if (gStorage.stats.rightList.tab === TAB_MONTH) {
				let m = gStorage.stats.rightList.month;

				if (m >= 1 && m <= 12) {
					const y = gStorage.stats.rightList.year;

					desc += ' ' + t(monthNames[gStorage.stats.rightList.month - 1]);
					if (y) {
						desc += ', ' + y;
					}
				}
			} else if (gStorage.stats.rightList.tab === TAB_ASSO) {
				const y = gStorage.stats.rightList.year;

				desc += ' ' + gStorage.lists.assolist.list.find(l => l.id === gStorage.stats.rightList.location).nick;

				if (y) {
					desc += ', ' + y;
				}
			}

			if (gStorage.stats.rightList.country && (tab !== TAB_LOC && tab !== TAB_OBS && tab !== TAB_ASSO)) {
				desc += ' (' + getCountryName(gStorage.lists.countrylist.find(x => x.id === gStorage.stats.rightList.country), gStorage.conn.user) + ')';
			}

		} else {
			desc += '-';
		}

		return desc;
	}

	function compareSrc() {
		let list = [], ret = [], left_i, right_i, neutral_i;

		if (gStorage.stats.tab !== TAB_COMPARE || !gStorage.stats.leftList.list.length || !gStorage.stats.rightList.list.length)
			return null;

		gStorage.stats.leftList.list.forEach((obs) => {
			let obs2 = gStorage.stats.rightList.list.find(x => x.spec_id === obs.spec_id);
			if (!obs2) {
				list.push({...obs, missing: -1});
			}
		});

		gStorage.stats.rightList.list.forEach((obs) => {
			let obs2 = gStorage.stats.leftList.list.find(x => x.spec_id === obs.spec_id);
			if (!obs2) {
				list.push({...obs, missing: 1});
			}
		});

// 		console.log('compareSrc', list);

		left_i = 0;
		right_i = 0;
		neutral_i = 0;

		let ol = list.length, i;

		for (i = 0; i < ol; i++) {
			let obs = list[i], bg;

			bg = '#ffffff';

			if (obs.missing === -1) {
				bg = '#cbffe2';
				left_i++;
			} else if (obs.missing === 1) {
				bg = '#87ceeb';
				right_i++;
			} else {
				neutral_i++;
			}

			ret.push(
				<StatsRow
					key 	= {i + 1}
					bgcolor	= {bg}
					row_n 	= {obs.missing === -1 ? left_i : obs.missing === 1 ? right_i : neutral_i}
					obs 	= {obs}
				/>);
		}

// 		ret.sort((a, b) => {
// 			if (a.missing === b.missing) 
// 				return a.start_t - b.start_t;
// 			return a.missing - b.missing;
// 		});
		return ret;
	}

	if (gStorage.stats.tab !== TAB_COMPARE)
		return null;

	return (
		<div>
			<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0}>
				<Grid size={{xs: 12}} align={'center'}>
					<FormControl>
						{cmpDesc()}
					</FormControl>
				</Grid>
			</Grid>
			<TableContainer component={Paper} elevation={0}>
				<Table size='small'>
					<TableHead>
						<TableRow>
							<TableCell>#</TableCell>
							<TableCell>{t('main.species')}</TableCell>
							<TableCell>{t('main.time')}</TableCell>
							<TableCell>{t('main.location')}</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{compareSrc()}
					</TableBody>
				</Table>
			</TableContainer>
		</div>
	);
});

export default StatsCompare;
